module.exports = __webpack_public_path__ + "icomoon.950e91df.eot";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/fonts/icomoon/icomoon.eot
// module id = 1322
// module chunks = 1